/* eslint-disable no-unused-vars */
import { useCallback, useState } from 'react'
import { NavigateFunction, useNavigate } from 'react-router-dom'

import { ComplaintsReportSourceChoices, useReportQuery } from '@/apollo/graphql'
import { IReport, TFormSubmit } from '@/types'
import { useAPI } from '@/hooks/index'
import { homePath, transformData } from '@/utils/index'

interface IUseData {
  id?: string
}

const defaultData: Partial<IReport> = {
  source: ComplaintsReportSourceChoices.Police,
}

export const useData = ({ id }: IUseData) => {
  const navigate: NavigateFunction = useNavigate()
  const { submitting, sendForm } = useAPI()
  const [data, setData] = useState<any>(defaultData)

  const { loading } = useReportQuery({
    skip: !id,
    fetchPolicy: 'network-only',
    variables: {
      id: id || '',
    },
    onCompleted: res => {
      if (res.report) {
        setData({
          ...res.report,
          source: res.report.source || ComplaintsReportSourceChoices.Police,
        })
      }
    },
  })

  const onSubmit: TFormSubmit<IReport> = useCallback(
    (path, isEdit, callback) => d => {
      if (d.crimeTime) {
        d.crimeTime = new Date(d.crimeTime).toISOString()
      }
      if (d.issueTime) {
        d.issueTime = new Date(d.issueTime).toISOString()
      }
      sendForm(
        {
          path,
          method: isEdit ? 'PUT' : 'POST',
          data: transformData(d),
          callback,
        },
        { showNotify: true },
      )
    },
    [sendForm],
  )

  const onCancel = useCallback(() => {
    navigate(homePath)
  }, [navigate])

  return {
    loading,
    submitting,
    data,
    onSubmit,
    onCancel,
  }
}
